import { useParams, useLocation } from 'react-router-dom';
import ZoomVideoCall from '../ZoomSDK';
import VideoCall from '../VideoSDK';

const CallRouter = () => {
  const { meetingID } = useParams();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const callDataString = queryParams.get('data');

  let callData = null;

  try {
    callData = JSON.parse(decodeURIComponent(callDataString));
  } catch (err) {
    console.error("Failed to parse call data:", err);
    return <div>Error loading call data</div>;
  }

  if (callData.type === 'Zoom') {
    return <ZoomVideoCall meetingID={meetingID} token={callData.token} />;
  }

  if (callData.type === 'VideoSDK') {
    return <VideoCall />;
  }

  return <div>Unknown call type</div>;
};

export default CallRouter;